import React from 'react';

import PropTypes from 'prop-types';

import { cn } from '@/lib/utils';
import { appointmentShape } from '../../../../types';
import { isWithinWorkday } from '../../../../utils';
import { TIME_SLOT_HEIGHT } from '../constants';
import DateTimeCell from './DateTimeCell';

const TimeSlot = ({ appointmentsByDate, time, weekDates }) => {
  const timeStyles = cn(
    'flex justify-end pr-2 pt-1',
    'text-[11px] tabular-nums whitespace-nowrap',
    'border-b border-r',
    isWithinWorkday(time)
      ? 'text-foreground font-semibold'
      : 'text-muted-foreground bg-muted/40'
  );

  return (
    <>
      <div className={timeStyles} style={{ height: TIME_SLOT_HEIGHT }}>
        {time}
      </div>

      {weekDates.map((date) => (
        <DateTimeCell
          appointments={appointmentsByDate[date.toDateString()]}
          key={date.toISOString()}
          time={time}
        />
      ))}
    </>
  );
};

const appointmentsByDateShape = PropTypes.shape({
  [PropTypes.string]: PropTypes.arrayOf(appointmentShape).isRequired,
}).isRequired;

TimeSlot.propTypes = {
  appointmentsByDate: appointmentsByDateShape.isRequired,
  time: PropTypes.string.isRequired,
  weekDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)).isRequired,
};

export default TimeSlot;
